import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Cookies from 'js-cookie'
import animate from 'animate.css'
import store from "./store";
import echarts from 'echarts' 
Vue.prototype.$echarts = echarts 

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import './css/common.css' 
import './utils.js'

import './permission.js'

import {getBaseUrl,timerlog} from './utils/config'
import {postlogin} from './api/base'
Vue.prototype.$url=getBaseUrl();

import Utils from './utils/common'
Vue.prototype.utils=Utils;

Vue.config.productionTip = false

import heartbeat from './components/heartbeat.js'
Vue.use(heartbeat)

window.onload  = ()=>{
   
   setInterval(()=>{
    let ischaoshi = Utils.sessionGet("chaoshi");
    if(ischaoshi ==1){

    }else{
      postlogin({ModeType:''});
    }
    
   },7000);
}

new Vue({
  render: h => h(App),
  router,
	store,
}).$mount('#app')

 